import * as moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';
// utils
import { Translations, convertStringToArray, electOwningCase, isAdmin } from '../../../utils';
// constant
import { DarkTitlebarData } from './json_dark-title-bar';
// restClient
import { aemHostClient, eapiClient, taxonomyHostClient } from '../../../restClient';

import { resetCaseListFilter } from '../../CaseList/actions/actionCreator';
// children
import Banner from '../../common/Banner/';
import Tooltip from '../../common/Tooltip';
//action Creator
import { resetStore } from '../../../actions/actionCreator';
import { decryptData } from '../../../utils';
import { caseMenuInfo } from '../../common/CaseMenu/actions/actionCreator';
import { setDarkTitleBarContent, setLanguage, setTranslatedData, showDarkTitleBarActionModal } from '../actions/actionCreator';

//style
import { resetSowEntities } from '../../createASow/actions/actionCreator';
import './darkTitlebar.css';

class DarkTitleBar extends Component {

  constructor(props) {
    super(props);
    this.state = {
      active: false,
      bannersVisibility: {},
      showAdminActionButton: true
    };
    this.lang = {};
  }

  toggleTooltip = () => {
    this.setState({
      active: !this.state.active
    })
  }
  componentWillMount() {
    // aemHostClient("/aemData/formData/json_dark-title-bar")
    //   .then(({ data }) => {
    //     this.setState({ darkTitlePagejson: data });
    //   });

    if (this.props.staticHeading === 'true') {
      this.setState({ darkTitlePagejson: DarkTitlebarData });
    }
  }

  getCaseDetails(status) {
    var statusValue;
    var caseStatuses = this.state.caseStatus || this.props.caseStatuses;
    if (caseStatuses !== undefined) {
      if (status !== undefined) {
        caseStatuses.filter(countItem => {
          if (countItem.id === status) {
            statusValue = countItem.name;
          }
        });
        return statusValue
      }
    }
  }

  componentWillReceiveProps(nextProps) {

    if (this.props.staticHeading !== nextProps.staticHeading) {
      aemHostClient("/aemData/formData/json_dark-title-bar")
        .then(({ data }) => {
          this.setState({ darkTitlePagejson: data });
        });
    }


    if (nextProps.lang.currentLang.lang !== this.props.lang.currentLang.lang) {
      aemHostClient("/aemData/formData/json_dark-title-bar")
        .then(({ data }) => {
          taxonomyHostClient(Translations(data.par.static_text_darkTitleBar.CaseStatusapi, this.props.lang.currentLang.lang, this.props.lang.translatedData))
            .then(({ data }) => {
              this.setState({ caseStatus: data.responseData.classificationNodes[0].associations })
            })
        })
    }

  }
  showBackToCaseLink = () => {
    if (this.props.history.location.pathname.includes("view-entity-profile") ||
      this.props.history.location.pathname.includes("admin-panel")) {
      return true;
    }
    return false;
  }

  goBackToCreateCase = () => {
    if (this.props.history.location.pathname === "/admin-panel") {
      this.props.history.push("/case-list");
    } else if (this.props.history.location.pathname === "/admin-panel/create-group/"
      || this.props.history.location.pathname === "/admin-panel/create-edit-case/"
      || this.props.history.location.pathname === "/admin-panel/add-product") {
      this.props.history.push("/admin-panel");
    } else {
      this.props.history.goBack();
    }
  }

  getValueFromKey(key = "") {
    return key.split(":").pop();
  }

  getDisplayDate(date) {
    return moment(date).format("DD MMM YY");
  }

  getCaseOwner = () => {
    if (this.props.currentCase) {
      return this.props.currentCase.caseOwner ? this.props.currentCase.caseOwner.name : 'N/A';
    }
    return 'N/A';
  }

  getCasePackName = () => `${this.props.currentCase._caseId}`;

  performCaseSetupToCaseListNavigation = () => {
    var shouldShowActionModal = false;
    this.lang = this.props.lang;
    var noOfEntities = Object.keys(this.props.entities).length;
    var noOfCases = Object.keys(this.props.cases).length;
    if (noOfEntities !== 0 && noOfEntities !== noOfCases) {
      shouldShowActionModal = true;
    }
    if (shouldShowActionModal) {
      this.props.showDarkTitleBarActionModal();
    } else {
      this.props.resetStore(this.lang);
      this.props.history.push("/case-list");
    }
  }
  performSOWSetupToCaseListNavigation = () => {
    this.props.history.push("/case-list");
  }

  getTitleName = () => {
    if (this.props.pageTitle !== undefined) {
      if (this.props.pageTitle === "Welcome to your case" || this.props.pageTitle === "Bienvenido a su caso" || this.props.pageTitle === "Selamat Datang di Kasus Anda") {
        return Translations(this.state.darkTitlePagejson.par.static_text_darkTitleBar.welcome, this.props.lang.currentLang.lang, this.props.lang.translatedData);
      } else if (this.props.pageTitle === "Create case" || this.props.pageTitle === "Crear caso" || this.props.pageTitle === "Buat kasus") {
        return Translations(this.state.darkTitlePagejson.par.static_text_darkTitleBar.createCase, this.props.lang.currentLang.lang, this.props.lang.translatedData);
      } else {
        return this.props.pageTitle;
      }
    }
  }

  getButtonText = () => {
    if (this.props.actionButtontext !== undefined) {
      if (this.props.actionButtontext === "Case List" || this.props.actionButtontext === "Lista de casos" || this.props.actionButtontext === "Daftar kasus") {
        return Translations(this.state.darkTitlePagejson.par.static_text_darkTitleBar.caseList, this.props.lang.currentLang.lang, this.props.lang.translatedData);
      } if (this.props.actionButtontext === "Exit case" || this.props.actionButtontext === "Salir del caso" || this.props.actionButtontext === "Keluar dari Kasus") {
        return Translations(this.state.darkTitlePagejson.par.static_text_darkTitleBar.exitCase, this.props.lang.currentLang.lang, this.props.lang.translatedData);
      } else {
        return this.props.actionButtontext;
      }
    }
  }
  performCreateSOWButtonAction = () => {
    this.props.resetSowEntities()
    this.props.history.push("/create-a-sow/create-new-entity");
  }

  performDarkTitleBarAction = async () => {
    if (this.props.history.location.pathname.includes("case-body")) {

      let caseId = this.props.owningCase.caseId;
      let tab = ''
      if (caseId === undefined || caseId === null) {
        caseId = window.localStorage.getItem('owningCase');
      }
      const pageUrl = window.location.pathname;
      let tabValue = window.localStorage.getItem("tab");
      if (tabValue !== undefined && tabValue !== null && tabValue !== '') {
        tab = await decryptData(tabValue,);
      }
      eapiClient("/cases/" + caseId + "/exitCase", {
        method: 'PUT',
        timeout: 100000,
        data: { pageUrl: pageUrl, event: "Exit button click", tab: tab }
      })
      window.localStorage.removeItem('owningCase');
      window.localStorage.removeItem('token');
      window.localStorage.removeItem('customer');
      this.props.resetCaseListFilter()
      this.props.history.push("/case-list");
      this.props.resetStore(this.props.lang);
    } else if (this.props.history.location.pathname.includes("create-a-case") && (!this.props.history.location.pathname.includes("create-new"))) {
      //resetting case list filters
      this.props.resetCaseListFilter()
      this.performCaseSetupToCaseListNavigation();
    }
    else if (this.props.history.location.pathname.includes("sow-body") || this.props.history.location.pathname.includes("sow/body")) {
      const pageUrl = window.location.pathname;
      let agentDetail = this.props.sowEntities.filter(entity => {
        return entity.agent
      })
      let apiURL = "/sows/" + agentDetail[0].groupId + '/exitSow';
      var METHOD = 'PUT';
      eapiClient(apiURL, {
        method: METHOD,
        timeout: 100000,
        data: { pageUrl: pageUrl, event: "Exit button click" }
      })
        .then(({ data }) => {

          // eapiClient('/sows/' + agentDetail[0].groupId + '/menu')
          //   .then(({ data }) => {
          //     //this.setState({RefreshData :data.responseData })
          //     //  this.props.caseMenuInfo(data.responseData)
          //   });
        });

      this.performSOWSetupToCaseListNavigation();

    }
    else if (this.props.history.location.pathname.includes("create-a-sow")) {
      this.performSOWSetupToCaseListNavigation();
    } else if (this.props.history.location.pathname.includes("case-list")) {
      //resetting case list filters
      this.props.resetCaseListFilter()
      if (this.props.userDetails && (this.props.userDetails.roleDetails.role.name === "Sales Manager")) {
        this.props.resetSowEntities()
        this.props.history.push("/create-a-sow/create-new-entity");
      } else {
        this.props.history.push("/create-a-case/select-entity");
      }
    }
  }

  performAdminAction = () => {
    //resetting case list filters
    this.props.resetCaseListFilter()
    this.props.history.push('/admin-panel');
  }

  render() {
    const backBtnJsx = (<label tabIndex="0" role="link" className="back-action" onClick={this.goBackToCreateCase}><i className="icon icon-chevron-left"></i>{this.state.darkTitlePagejson !== undefined ? this.props.history.location.pathname.includes("admin-panel/create-edit-case") ? Translations(this.state.darkTitlePagejson.par.static_text_darkTitleBar.backToAdmin, this.props.lang.currentLang.lang, this.props.lang.translatedData) : Translations(this.state.darkTitlePagejson.par.static_text_darkTitleBar.backToCase, this.props.lang.currentLang.lang, this.props.lang.translatedData) : ''}</label>);
    const otherText = this.state.darkTitlePagejson !== undefined ? Translations(this.state.darkTitlePagejson.par.static_text_darkTitleBar.others, this.props.lang.currentLang.lang, this.props.lang.translatedData) : ''
    let editModeWarning = this.state.darkTitlePagejson !== undefined ? Translations(this.state.darkTitlePagejson.par.static_text_darkTitleBar.editModeWarning, this.props.lang.currentLang.lang, this.props.lang.translatedData) : ''
    editModeWarning = editModeWarning !== undefined ? convertStringToArray(editModeWarning) : '';

    return (
      (this.state.darkTitlePagejson !== undefined ?
        <div className="dark-title-bar clearfix">
          {
            this.props.caseMenu !== undefined && this.props.caseMenu.isEditing && this.props.caseMenu.editingUserEmail !== this.props.userDetails.emailAddress &&
              (this.props.history.location.pathname.includes("case-body") || this.props.history.location.pathname.includes("sow-body"))
              ? <Banner
                bannerType="warning"
                bannerId="ci-customer-banner"
                hide={this.state.bannersVisibility['ci-customer-banner']}
              >
                {editModeWarning !== undefined ? `${editModeWarning[0]} ${this.props.caseMenu.isEditingUser}${editModeWarning[1]}, ${editModeWarning[2]}` : ''}
              </Banner> : ''
          }
          <div className="dark-title-bar__content gdocs-flex-wrap">
            {
              this.props.pageTitle !== undefined ?
                <div id="main" tabIndex="-1" aria-label={
                  this.getTitleName() || Translations(this.state.darkTitlePagejson.par.static_text_darkTitleBar.glcm, this.props.lang.currentLang.lang, this.props.lang.translatedData)
                } className="gdocs-flex-1">
                  <div className="dark-title-bar__left-area gdocs-responsive-text gdocs-width-mw-100-i">
                    <h2 className="title">
                      {
                        this.getTitleName() || Translations(this.state.darkTitlePagejson.par.static_text_darkTitleBar.glcm, this.props.lang.currentLang.lang, this.props.lang.translatedData)
                      }
                    </h2>
                    {
                      this.props.auth.isAuthenticated ? (
                        <div className="action-bar">
                          {this.showBackToCaseLink() ? backBtnJsx : ""}
                          {
                            this.props.history.location.pathname.includes("case-body") ?
                              (
                                <div className="case-body-action-bar">
                                  <dl>
                                    <dt>{`${Translations(this.state.darkTitlePagejson.par.static_text_darkTitleBar.case, this.props.lang.currentLang.lang, this.props.lang.translatedData)}: `}</dt>
                                    <dd>
                                      {this.getCasePackName()}
                                      <span>
                                        {
                                          Object.keys(this.props.cases).length > 1
                                            ? (<div className="other-case-details-container">
                                              <span
                                                className="tooltip-link"
                                                data-tooltip="case-ids"
                                                onMouseEnter={this.toggleTooltip}
                                                onClick={this.toggleTooltip}
                                                onMouseLeave={this.toggleTooltip}
                                              >
                                                {`(+${Object.keys(this.props.cases).length - 1} ${otherText})`}
                                              </span>
                                              <Tooltip
                                                active={this.state.active}
                                                position="bottom"
                                                arrow="center"
                                                parent="case-ids"
                                              >
                                                <ul className="tooltip-content-list">
                                                  {
                                                    this.props.casesExcludingOwningCase.map(eCase => (
                                                      <li className="tooltip-content-list__item" key={eCase.id}>
                                                        <div><strong>{eCase.entityName}</strong></div>
                                                        <div>{`ID: ${eCase._caseId}`}</div>
                                                      </li>
                                                    ))
                                                  }
                                                </ul>
                                              </Tooltip>
                                            </div>)
                                            : ""
                                        }
                                      </span>
                                    </dd>
                                    <dt>{` | ${Translations(this.state.darkTitlePagejson.par.static_text_darkTitleBar.created, this.props.lang.currentLang.lang, this.props.lang.translatedData)}: `}</dt>
                                    <dd>{this.getDisplayDate(this.props.currentCase.createdOn)}</dd>
                                    <dt>{` | ${Translations(this.state.darkTitlePagejson.par.static_text_darkTitleBar.owner, this.props.lang.currentLang.lang, this.props.lang.translatedData)}: `}</dt>
                                    <dd>{this.getCaseOwner()}</dd>
                                    <dt>{` | ${Translations(this.state.darkTitlePagejson.par.static_text_darkTitleBar.status, this.props.lang.currentLang.lang, this.props.lang.translatedData)}: `}</dt>
                                    <dd>{this.props.currentCase.caseId !== undefined && this.props.cases[this.props.currentCase.caseId] !== undefined ? this.getCaseDetails(this.props.cases[this.props.currentCase.caseId].status) : this.props.currentCase.status}</dd>
                                  </dl>
                                </div>
                              ) : ""
                          }
                          {
                            this.props.history.location.pathname.includes("sow-body") ?
                              (
                                <div className="case-body-action-bar">
                                  <dl>
                                    <dt>{`${Translations(this.state.darkTitlePagejson.par.static_text_darkTitleBar.sow, this.props.lang.currentLang.lang, this.props.lang.translatedData)}: `}</dt>
                                    <dd>{this.props.sowEntities[0].entityId}</dd>
                                    <dt>{` | ${Translations(this.state.darkTitlePagejson.par.static_text_darkTitleBar.created, this.props.lang.currentLang.lang, this.props.lang.translatedData)}: `}</dt>
                                    <dd>{this.getDisplayDate(this.props.sowEntities[0].createdOn)}</dd>
                                    <dt>{` | ${Translations(this.state.darkTitlePagejson.par.static_text_darkTitleBar.owner, this.props.lang.currentLang.lang, this.props.lang.translatedData)}: `}</dt>
                                    <dd>{this.props.sowDetail && this.props.sowDetail.caseOwner && this.props.sowDetail.caseOwner.name}</dd>
                                    <dt>{` | ${Translations(this.state.darkTitlePagejson.par.static_text_darkTitleBar.status, this.props.lang.currentLang.lang, this.props.lang.translatedData)}: `}</dt>
                                    <dd>{this.props.sowDetail.statusValue}</dd>
                                  </dl>
                                </div>
                              ) : ""
                          }
                        </div>
                      ) : ''
                    }
                  </div>
                </div> : ''
            }
            <div className="action-buttons">
              {
                this.props.isAdmin && this.props.history.location.pathname.includes("/case-list") && this.state.showAdminActionButton
                  ? (
                    <button onClick={this.performAdminAction} className="gdocs-admin-panel-btn">
                      <div className='gdocs-btn-with-icon_flex'>
                        <i className="icon icon-settings" aria-hidden='true'></i>
                        {Translations(this.state.darkTitlePagejson.par.static_text_darkTitleBar.admin, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
                      </div>
                    </button>
                  ) : ''
              }
              {
                this.props.showActionbutton ?
                  (<button onClick={this.performDarkTitleBarAction} className="gdocs-darktitlebar-btn">
                    <div className='gdocs-btn-with-icon_flex'>
                      {
                        this.props.actionButtonIcon
                          ? <i className={this.props.actionButtonIcon} aria-hidden='true'></i>
                          : ''
                      }
                      {this.getButtonText()}
                    </div>
                  </button>
                  ) : ''
              }
              {
                this.props.userDetails && this.props.userDetails.roleDetails.role.name === 'Admin' && this.props.history.location.pathname.includes("case-list") ?
                  (<button onClick={this.performCreateSOWButtonAction} className="gdocs-darktitlebar-btn">
                    <div className='gdocs-btn-with-icon_flex'>
                      {
                        this.props.actionButtonIcon
                          ? <i className={this.props.actionButtonIcon} aria-hidden='true'></i>
                          : ''
                      }
                      Create SOW
                    </div>
                  </button>
                  ) : ''
              }
            </div>
          </div>
        </div> : ''));
  }
}

const mapStateToProps = state => {
  const owningCase = electOwningCase(state.cases);
  var casesExcludingOwningCase = [];
  for (var caseId in state.cases) {
    if (caseId !== owningCase.id) {
      casesExcludingOwningCase.push(state.cases[caseId]);
    }
  }

  return {
    auth: state.auth,
    pageTitle: state.darkTitleBar.pageTitle,
    currentCase: state.darkTitleBar.currentCase,
    caseStatuses: state.darkTitleBar.caseStatus,
    showActionbutton: state.darkTitleBar.showActionbutton || false,
    actionButtontext: (state.darkTitleBar.showActionbutton === true ? state.darkTitleBar.actionButtontext : undefined),
    actionButtonIcon: (state.darkTitleBar.actionButtonIcon !== undefined ? state.darkTitleBar.actionButtonIcon : undefined),
    entities: state.entities,
    cases: state.cases,
    caseMenu: state.caseMenuInfo,
    userDetails: state.auth.userDetails,
    casesExcludingOwningCase,
    isAdmin: isAdmin(state.auth),
    owningCase: electOwningCase(state.cases),
    lang: state.lang,
    sowEntities: (state.sowEntities && state.sowEntities.savedSow && state.sowEntities.savedSow.entity) || [],
    sowDetail: (state.sowEntities && state.sowEntities.savedSow)
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setDarkTitleBarContent: (pageTitle) => {
      dispatch(setDarkTitleBarContent(pageTitle))
    },
    showDarkTitleBarActionModal: () => {
      dispatch(showDarkTitleBarActionModal());
    },
    resetStore: (lang) => {
      dispatch(resetStore(lang))
    },
    setLanguage: lang => {
      dispatch(setLanguage(lang));
    },
    setTranslatedData: translatedData => {
      dispatch(setTranslatedData(translatedData))
    },
    resetCaseListFilter: filterData => {
      dispatch(resetCaseListFilter(filterData))
    },
    resetSowEntities: () => {
      dispatch(resetSowEntities())
    },
    caseMenuInfo: caseMenuData => {
      dispatch(caseMenuInfo(caseMenuData))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DarkTitleBar);


// WEBPACK FOOTER //
// ./src/components/layouts/darkTitlebar/darkTitlebar.js